import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Zap, Heart, Home } from 'lucide-react';
export function SystemSection() {
  const phases = [{
    id: '01',
    title: 'Descarga',
    description: 'Liberá la carga acumulada en menos de 5 minutos.',
    icon: Zap
  }, {
    id: '02',
    title: 'Armonización',
    description: 'Reconectá con tu centro interno.',
    icon: Heart
  }, {
    id: '03',
    title: 'Limpieza de Ambientes',
    description: 'Ordená tu entorno para sostener tu estabilidad.',
    icon: Home
  }];
  return <SectionWrapper data-id="element-115">
      {/* Header with mockup image */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center mb-20" data-id="element-116">
        <div className="text-left" data-id="element-117">
          <h2 className="text-4xl md:text-5xl text-text mb-4" data-id="element-118">
            Método ProMind Energy™
          </h2>
          <p className="text-lg md:text-xl text-text-secondary leading-relaxed" data-id="element-119">
            Sistema de Regulación Energética Cotidiana en 3 Fases
          </p>
        </div>
        <div className="w-full overflow-hidden" data-id="element-120">
          <img src="https://cdn.magicpatterns.com/uploads/w4psXpePDtFD7KMyNoYLR4/mockup.png" alt="Mockup del Método ProMind Energy con todos los materiales incluidos" className="w-full h-auto object-contain" data-id="element-121" />
        </div>
      </div>

      {/* Phase cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-122">
        {phases.map(phase => <div key={phase.id} className="border border-border-custom p-8 flex flex-col items-center text-center bg-white/50 hover:bg-white transition-colors duration-300" data-id="element-123">
            <span className="text-xs font-bold tracking-widest text-plum mb-6 uppercase" data-id="element-124">
              Fase {phase.id}
            </span>
            <phase.icon className="w-8 h-8 text-text-secondary mb-6" strokeWidth={1.5} data-id="element-125" />
            <h3 className="text-2xl text-text mb-4" data-id="element-126">{phase.title}</h3>
            <p className="text-text-secondary leading-relaxed" data-id="element-127">
              {phase.description}
            </p>
          </div>)}
      </div>

      {/* Authority block below cards */}
      <div className="max-w-[680px] mx-auto text-center mt-20" data-id="element-128">
        <p className="text-lg md:text-xl text-text-secondary leading-relaxed" data-id="element-129">
          ProMind Energy no es una práctica suelta. Es un método estructurado
          diseñado para que recuperes tu estabilidad en menos de 15 minutos.
        </p>
      </div>
    </SectionWrapper>;
}